import { ApiError } from '../api/client';
import { recordOnboardingEvent } from '../api/onboarding';
import type { OnboardingErrorStep } from '../types/onboarding';

// P-085 · lo que la app reporta al embudo del onboarding (docs/p085/FUNNEL-P085.md). Todo de mejor esfuerzo: nada de
// aquí cambia lo que la persona ve ni espera respuesta. Nunca viaja texto libre: solo códigos de una lista cerrada.

const CODE_PATTERN = /^[A-Z][A-Z0-9_]{2,63}$/;

/** El código de un error para el embudo: el del servidor si es un código estable; si no, uno genérico. Pura. */
export function onboardingErrorCode(error: unknown): string {
  if (error instanceof ApiError) {
    const code = error.payload?.error;
    if (typeof code === 'string' && CODE_PATTERN.test(code)) return code;
    if (error.status === 0) return 'NETWORK_ERROR';
    return error.status >= 500 ? 'SERVER_ERROR' : 'VALIDATION_ERROR';
  }
  if (error instanceof TypeError) return 'NETWORK_ERROR';
  return 'UNKNOWN_ERROR';
}

/** Un paso del onboarding falló: queda su paso y su código (nunca el mensaje). */
export function noteOnboardingError(step: OnboardingErrorStep, error: unknown): void {
  noteOnboardingErrorCode(step, onboardingErrorCode(error));
}

/** Igual, cuando la pantalla ya sabe el código (siempre de la lista: mayúsculas, dígitos y guion bajo). */
export function noteOnboardingErrorCode(step: OnboardingErrorStep, code: string): void {
  recordOnboardingEvent({ event: 'onboarding_error', step, code: CODE_PATTERN.test(code) ? code : 'UNKNOWN_ERROR' });
}

const posKey = (businessId: string) => `n360.p085.posAbierto.${businessId}`;

/**
 * El dueño ENTRÓ a la vista del punto de venta (Codex R1, K3: montar «Ventas e ingresos» no es abrir el POS). Una vez por
 * sesión del navegador; el servidor además deduplica por negocio y solo cuenta al dueño de un negocio guiado.
 */
export function notePosOpened(businessId: string | undefined): void {
  if (!businessId) return;
  try {
    if (sessionStorage.getItem(posKey(businessId)) === '1') return;
    sessionStorage.setItem(posKey(businessId), '1');
  } catch {
    // Sin almacenamiento de sesión se manda igual: el servidor lo deduplica.
  }
  recordOnboardingEvent({ event: 'pos_opened' });
}
